/**
 * Title row of the extranet cards (`Card.Header` content): optional icon,
 * the (override-resolved) title, an optional count pill and a trailing slot.
 *
 * Chrome helper of the shared cards — not registered.
 */

import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

import { Badge, Icon, Text } from '@components/base/display';

export interface CardTitleRowProps {
  title: string;
  icon?: LucideIcon;
  /** Count pill after the title (omitted ⇒ none). */
  count?: number;
  /** Right-aligned content (actions). */
  trailing?: ReactNode;
}

export function CardTitleRow({ title, icon, count, trailing }: Readonly<CardTitleRowProps>) {
  return (
    <div className="flex w-full items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-2">
        {icon && <Icon icon={icon} size="md" color="primary" />}
        <Text as="span" weight="semibold" size="base" truncate>
          {title}
        </Text>
        {count !== undefined && (
          <Badge variant="default" size="sm" pill>
            {count}
          </Badge>
        )}
      </div>
      {trailing && <div className="flex items-center gap-2">{trailing}</div>}
    </div>
  );
}
